import { CostsPanel } from "@/components/costs-panel";
import { SiteHeader } from "@/components/site-header";
import { TimeRangeSelector } from "@/components/time-range-selector";
import { queryKeys } from "@/lib/queryKeys";
import { costsProvider } from "@/providers/costs.provider";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

export function CostsPage() {
  const [days, setDays] = useState(30);

  const { data: costs, isLoading } = useQuery({
    queryKey: queryKeys.adminCosts(days),
    queryFn: () =>
      costsProvider.getCosts({
        from: new Date(Date.now() - days * 24 * 60 * 60 * 1000),
      }),
    staleTime: 60_000,
  });

  return (
    <>
      <SiteHeader title="Costs" />
      <div className="flex flex-1 flex-col">
        <div className="@container/main flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
            <div className="px-4 lg:px-6">
              <TimeRangeSelector days={days} onDaysChange={setDays} />
            </div>

            <CostsPanel costs={costs} isLoading={isLoading} days={days} />
          </div>
        </div>
      </div>
    </>
  );
}
